const str = (v) => (typeof v === 'string' ? v : v == null ? '' : String(v));

export function newLocationId() {
  return `loc_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

// settings/locations = { items: [{ id, name, address, startTime, endTime }] }
export function normalizeLocations(data) {
  if (!data || !Array.isArray(data.items)) return [];
  return data.items
    .filter((l) => l && typeof l === 'object')
    .map((l) => ({
      id: str(l.id) || newLocationId(),
      name: str(l.name),
      address: str(l.address),
      startTime: str(l.startTime),
      endTime: str(l.endTime),
    }));
}

export function cleanLocations(items) {
  return items
    .map((l) => ({
      id: l.id || newLocationId(),
      name: l.name.trim(),
      address: l.address.trim(),
      startTime: l.startTime.trim(),
      endTime: l.endTime.trim(),
    }))
    .filter((l) => l.name);
}

export function findSavedByName(list, name) {
  const n = (name || '').trim().toLowerCase();
  if (!n) return null;
  return list.find((l) => l.name.trim().toLowerCase() === n) || null;
}
